if($('.p-news__header').length){
	$('.p-newsHeader__current').click(function(){
		$('.p-newsHeader__category').toggleClass('is-open')
	})
};
